import gql from 'graphql-tag';

export const MediaUploadTokenQuery = gql`
	query MediaUploadTokenQuery($contentId: ID!) {
		contentMediaSession(contentId: $contentId) {
			token {
				value
			}
			configuration {
				clientId
				fileStoreUrl
			}
			collection
		}
	}
`;

export const CommentMediaUploadTokenQuery = gql`
	query CommentMediaUploadTokenQuery($cloudId: ID!, $contentId: ID!) {
		contentMediaSession: confluence_commentMediaSession(cloudId: $cloudId, contentId: $contentId) {
			token {
				value
			}
			configuration {
				clientId
				fileStoreUrl
			}
			collection
		}
	}
`;
